import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { formatDecimal } from "../../utils/Utils";

const ExportAllData = () => {
  const { t, i18n } = useTranslation();
  const cips = useSelector((state) => state.cips);
  const backwashes=useSelector((state) => state.backwashes);
  const cleaningEffectiness = useSelector((state) => state.cleaningEffectiness);
  const operationalTime = useSelector((state) => state.operationalTime);
  const waterRecovery = useSelector((state) => state.waterRecovery);
  const fouling = useSelector((state) => state.fouling);
  // Plant Details
  const plantName = useSelector((state) => state.plantName);
  const plantLocation = useSelector((state) => state.plantLocation);
  const water_type = useSelector((state) => state.water_type);
  const num_trains = useSelector((state) => state.num_trains);
  const tol_num_modules = useSelector((state) => state.tol_num_modules);
  const tol_active_area = useSelector((state) => state.tol_active_area);
  const dataset_name = useSelector((state) => state.dataset_name);
  // Selected setion details
  const sel_train = useSelector((state) => state.sel_train);
  const sel_rack = useSelector((state) => state.sel_rack);
  const sel_modules_per_rack = useSelector(
    (state) => state.sel_modules_per_rack
  );
  const sel_active_area = useSelector((state) => state.sel_active_area);
  const sel_module_used = useSelector((state) => state.sel_module_used);
  const is_dupont_element = useSelector((state) => state.is_dupont_element);
  const sel_segment = useSelector((state) => state.sel_segment);
  // settings
  const flow = useSelector((state) => state.flow);
  const mass = useSelector((state) => state.mass);
  const feed_suspended = useSelector((state) => state.feed_suspended);
  const pressure = useSelector((state) => state.pressure);
  const flux = useSelector((state) => state.flux);
  const filtrate_suspended = useSelector((state) => state.filtrate_suspended);
  const volume = useSelector((state) => state.volume);
  const temperature = useSelector((state) => state.temperature);
  const currency = useSelector((state) => state.currency);
  const conversion_rate = useSelector((state) => state.conversion_rate);
  // Cost Information
  const engryPrice = useSelector((state) => state.energyPrice);
  const cipWaterPrice = useSelector((state) => state.waterPrice);
  const costofDownTime = useSelector((state) => state.costofDownTime);
  const cipAcidPrice = useSelector((state) => state.acidPrice);
  const cipAlkaliPrice = useSelector((state) => state.alkaliPrice);
  const additional_chemical_price = useSelector(
    (state) => state.additional_chemical_price
  );
  const cebAcidPrice = useSelector((state) => state.cebAcidPrice);
  const cebAlkaliPrice = useSelector((state) => state.cebAlkaliPrice);
  const ceb_additional_chemical_price = useSelector(
    (state) => state.ceb_additional_chemical_price
  );
  // Default cip/ceb/bw information
  const design_duration_btw_bw = useSelector(
    (state) => state.design_duration_btw_bw
  );
  const design_bw_duration = useSelector((state) => state.design_bw_duration);
  const acid_ceb_duration = useSelector((state) => state.acid_ceb_duration);
  const acid_ceb_soak_duration = useSelector(
    (state) => state.acid_ceb_soak_duration
  );
  const acid_used_per_ceb = useSelector((state) => state.acid_used_per_ceb);
  const acid_ceb_ph = useSelector((state) => state.acid_ceb_ph);
  const acid_ceb_temp = useSelector((state) => state.acid_ceb_temp);
  const alkali_ceb_duration = useSelector((state) => state.alkali_ceb_duration);
  const alkali_ceb_soak_duration = useSelector(
    (state) => state.alkali_ceb_soak_duration
  );
  const alkali_used_per_ceb = useSelector((state) => state.alkali_used_per_ceb);
  const alkali_ceb_ph = useSelector((state) => state.alkali_ceb_ph);
  const alkali_ceb_temp = useSelector((state) => state.alkali_ceb_temp);
  const acid_cip_duration = useSelector((state) => state.acid_cip_duration);
  const acid_cip_soak_duration = useSelector(
    (state) => state.acid_cip_soak_duration
  );
  const acid_used_per_cip = useSelector((state) => state.acid_used_per_cip);
  const acid_cip_ph = useSelector((state) => state.acid_cip_ph);
  const acid_cip_temp = useSelector((state) => state.acid_cip_temp);
  const alkali_cip_duration = useSelector((state) => state.alkali_cip_duration);
  const alkali_cip_soak_duration = useSelector(
    (state) => state.alkali_cip_soak_duration
  );
  const alkali_used_per_cip = useSelector((state) => state.alkali_used_per_cip);
  const alkali_cip_ph = useSelector((state) => state.alkali_cip_ph);
  const alkali_cip_temp = useSelector((state) => state.alkali_cip_temp);

  // Advance settings

  const window = useSelector((state) => state.window);
  const qp_pct_change_threshold = useSelector(
    (state) => state.qp_pct_change_threshold
  );
  const tmp_pct_change_threshold = useSelector(
    (state) => state.tmp_pct_change_threshold
  );
  const short_time_threshold = useSelector(
    (state) => state.short_time_threshold
  );
  const default_approach = useSelector((state) => state.default_approach);
  const time1 = useSelector((state) => state.time1);
  const time2 = useSelector((state) => state.time2);
  const minimum_duration_between_cips = useSelector((state) => state.minimum_duration_between_cips);
  const norm_tmp_threshold = useSelector((state) => state.norm_tmp_threshold);
  const filtrate_flow_threshold = useSelector(
    (state) => state.filtrate_flow_threshold
  );
  const start_tmp_pct_change_threshold = useSelector(
    (state) => state.start_tmp_pct_change_threshold
  );
  const minimum_backwash_between_cips = useSelector(
    (state) => state.minimum_backwash_between_cips
  );
  const minimum_backwash_between_cebs = useSelector(
    (state) => state.minimum_backwash_between_cebs
  );
  const min_shutdown_days = useSelector((state) => state.min_shutdown_days);
  const norm_tmp_threshold_cip = useSelector(
    (state) => state.norm_tmp_threshold_cip
  );
  const optimize_mode = useSelector((state) => state.optimize_mode);
  const min_bwd_multiplier = useSelector((state) => state.min_bwd_multiplier);
  const max_bwd_multiplier = useSelector((state) => state.max_bwd_multiplier);
  const optimization_target = useSelector((state) => state.optimization_target);
  // const installation_date = useSelector((state) => state.installation_date);
  // const warranty = useSelector((state) => state.warranty);
  // const app = useSelector((state) => state.app);

  const [exportAllData, setExportAllData] = useState({
    userCips: cips?.filter((item) => !item.is_tool_identified),
    cips,
    backwashes,
    cleaningEffectiness,
    fouling,
    others: [
      {
        plantName,
        plantLocation,
        water_type,
        num_trains,
        tol_num_modules,
        tol_active_area,
        dataset_name,
        // ...(app === "ra" && {
        //   installation_date: installation_date,
        //   warranty: warranty,
        // }),
        sel_train,
        sel_rack,
        sel_modules_per_rack,
        sel_active_area,
        sel_module_used,
        is_dupont_element: is_dupont_element
          ? t("ValueStrings.yes")
          : t("ValueStrings.no"),

        sel_segment,
        operational_time: formatDecimal(operationalTime, 1),
        water_recovery: formatDecimal(waterRecovery, 1),
        // settings
        flow,
        mass,
        feed_suspended,
        pressure,
        flux,
        filtrate_suspended,
        volume,
        temperature: `\u00B0${temperature}`,
        currency,
        conversion_rate,
        // cost information
        engryPrice,
        cipWaterPrice,
        costofDownTime,
        cipAcidPrice,
        cipAlkaliPrice,
        additional_chemical_price,
        cebAcidPrice,
        cebAlkaliPrice,
        ceb_additional_chemical_price,
        // Default Cip/ceb/bw information
        design_duration_btw_bw,
        design_bw_duration,
        acid_ceb_duration,
        acid_ceb_soak_duration,
        acid_used_per_ceb,
        acid_ceb_ph,
        acid_ceb_temp,
        alkali_ceb_duration,
        alkali_ceb_soak_duration,
        alkali_used_per_ceb,
        alkali_ceb_ph,
        alkali_ceb_temp,
        acid_cip_duration,
        acid_cip_soak_duration,
        acid_used_per_cip,
        acid_cip_ph,
        acid_cip_temp,
        alkali_cip_duration,
        alkali_cip_soak_duration,
        alkali_used_per_cip,
        alkali_cip_ph,
        alkali_cip_temp,
        // Advance settings
        window,
        qp_pct_change_threshold,
        tmp_pct_change_threshold,
        short_time_threshold,
        default_approach,
        time1,
        time2,
        minimum_duration_between_cips,
        norm_tmp_threshold,
        filtrate_flow_threshold,
        start_tmp_pct_change_threshold,
        minimum_backwash_between_cips,
        minimum_backwash_between_cebs,
        min_shutdown_days,
        norm_tmp_threshold_cip,
        optimize_mode: optimize_mode
          ? t("ValueStrings.yes")
          : t("ValueStrings.no"),
        min_bwd_multiplier,
        max_bwd_multiplier,
        optimization_target,
      }, //keep the order in sync with OthersTableStrings
    ],
  });

  return exportAllData;
};

export default ExportAllData;
